import React from 'react';
import { VINDex } from '../VINDex';

export class QuickLinksModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleClassName: 'in',
            modalHeight: 0,
            ajaxFailed: false
        };

        this.calculateModalHeight = this.calculateModalHeight.bind(this);
        this.vdxLinksLoaded = this.vdxLinksLoaded.bind(this);
        this.ajaxFailed = this.ajaxFailed.bind(this);
    }

    componentDidMount() {
        this.setState(this.calculateModalHeight);
    }

    componentWillUnmount() {
        this.setState({ toggleClassName: 'out' });
    }

    calculateModalHeight() {
        if ($j('#quickLinksModal').length > 0) {
            return {
                modalHeight: $j('#quickLinksModal .modal-dialog').outerHeight(true)
            };
        }
        else {
            return {
                modalHeight: 0
            };
        }
    }

    vdxLinksLoaded(data) {
        this.setState(this.calculateModalHeight);
        if (data) this.props.updateVINdexCache(data);
    }

    ajaxFailed() {
        this.setState({ ajaxFailed: true });
    }

    render() {
        const listClassName = this.state.ajaxFailed ? 'row error' : 'row';
        return (
            <div className={`modal ${this.state.toggleClassName}`} id="quickLinksModal" tabIndex="-1" role="dialog" aria-labelledby="quickLinksTitle" aria-hidden="false">
                <div className={`modal-backdrop ${this.state.toggleClassName}`} style={{ height: `${this.state.modalHeight}px` }}></div>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header promoPattern">
                            <button type="button" className="close" aria-label="Close" onClick={this.props.handleHideQL}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
                            <h4 className="modal-title" id="quickLinksTitle">Quick Links</h4>
                        </div>
                        <div className="modal-body">
                            <ul className={listClassName}>
                                <VINDex vdxLinksLoaded={this.vdxLinksLoaded} ajaxFailed={this.ajaxFailed} dataCache={this.props.dataCache} />
                            </ul>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" onClick={this.props.handleHideQL}>Close</button>
                        </div>
                    </div>
                </div>
            </div>  
        );
    }
}